console.log("init Proteus treatments -- 1.02")

// support for in-cart subscription management
document.addEventListener("change", async (e) => {
  if (!e.target.matches(".selling-plan-selector")) return;

  const lineKey = e.target.dataset.lineKey;
  const sellingPlanId = Number(e.target.value);

  await updateSellingPlan(lineKey, sellingPlanId);
});

document.addEventListener("click", async (e) => {
  if (!e.target.matches(".switch-to-2wk-plan")) return;

  const lineKey = e.target.dataset.lineKey;
  const sellingPlanId = Number(e.target.dataset.spId);

  await updateSellingPlan(lineKey, sellingPlanId);
});


async function updateSellingPlan(lineKey, sellingPlanId) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: lineKey,
      selling_plan: sellingPlanId
    })
  });

  const cart = await res.json();

  // tell the theme to refresh the cart UI
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: { cart }
    })
  );
}

//

async function submitVariantViaProductForm(variantId, qty = 1) {
  const form = document.getElementById("hidden-product-form");
  if (!form) throw new Error("Hidden product form missing");

  // fill inputs
  form.querySelector('input[name="id"]').value = String(variantId);
  form.querySelector('input[name="quantity"]').value = String(qty);

  // wrap the event-driven flow in a Promise so we can await completion
  const done = new Promise((resolve) => {
    const onRefresh = (e) => {
      // product-form will dispatch cart:refresh with sections; resolve after it fires
      document.documentElement.removeEventListener("cart:refresh", onRefresh);
      resolve(e.detail);
    };
    document.documentElement.addEventListener("cart:refresh", onRefresh, { once: true });
  });

  // triggers ProductForm._onSubmit -> theme ajax add + events
  form.requestSubmit();

  return done; // resolves with the cart:refresh detail
}

// atc links -- #atc--12345678-3456789
observeSelector('[href*="#atc--"]', atc_link => {

  if(document.querySelectorAll(`#hidden-product-form`).length == 0){
    document.querySelector('body').insertAdjacentHTML("beforeend", `
    <form is="product-form"
      id="hidden-product-form"
      action="/cart/add"
      method="post"
      style="display:none">
      <input type="hidden" name="id" value="">
      <input type="hidden" name="quantity" value="1">
    </form>  
    `);
  }

  atc_link.addEventListener("click", async (e) => {

    let atc_href = e.currentTarget.getAttribute("href");
    const match = atc_href.match(/#atc--([\d\-]+)/);
    if (!match) return;

    const var_ids = match[1].split("-"); // ["12345678", "3456789"]

    // Build items array for cart/add.js
    const items = var_ids.map(id => ({
      id,
      quantity: 1
    }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      console.log("Added multiple items:", data);

      waitForElement('#mini-cart').then(cart => {
        if(cart.open){
          cart.open = false;
        }

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
        }, (500));

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
          setTimeout(() => {
            document.querySelector('a[href="/cart"][is="toggle-link"]').click();
          }, (50));
        }, (2500));

      }).catch();

    } catch (err) {
      console.error("ATC error", err);
    }
  });
})

// joe: 40216908529798
// bar: 40216907939974

//
// START support for [IQB-02]
//
if(window.location.href.indexOf("qa=stayai") > -1 || window.sessionStorage.getItem("[IQB-02]")){

  console.log("init [IQB-02] v1")

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    [data-slidecart-item="42412052349062"]{
      display: none !important;
    }
    </style>  
    `);
  })

  window.sessionStorage.setItem("[IQB-02]", true);
  console.log(`init Stay.ai treatment`);

  const var_id = 42412052349062;
  const selling_plan_id = '5478088838';
  const custom_props = {
    '_source': '[IQB-02]'
  };

  const random_number = Math.floor(Math.random() * 1001);

  const review_cart = () => {
    console.log("review_cart()");

    fetch('/cart.js').then(res => res.json()).then(cart => {

      window.cart_data = cart;

      const anySellingPlanExists = cart.items.some(item => !!item.selling_plan_allocation);
      const hasThatVariant = cart.items.some(item => (item.variant_id ?? item.id) === Number(var_id));
      
      const targetIds = [6738720358534, 4425539977350, 6648412045446, 6875386839174]; // 4 sample products
      const hasSpecificProduct = cart.items.some(item =>
        targetIds.includes(Number(item.product_id))
      );

      console.log("hasThatVariant", hasThatVariant, "hasSpecificProduct", hasSpecificProduct);


      // if (!hasThatVariant && cart.items.length > 0) {
      if (!hasThatVariant && hasSpecificProduct) {

        console.log("add item");

        // Otherwise, add to cart and then checkout
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: var_id,
            quantity: 1,
            properties: custom_props,
            selling_plan: selling_plan_id
          })
        }).then(res => res.json()).then(data => {

          console.log('Item added to cart:', data);
          // window.location.href = "/checkout";
        });
      }

    }).catch(err => {
      console.error('Cart fetch or ATC failed:', err);
    });

  }; // review_cart()

  /*
  var_ids: 
  40172370690182 -- iqjoe-original-variety-16-sticks
  39796293861510 -- ultimate-sampler
  39589852184710 -- 8-flavor-variety
  31461251874950 -- 7-bar-trial
  */

  function debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  const debouncedReviewCart = debounce(review_cart, 500);

  observeSelector('[data-slidecart-item]', cart_item => {
    if(document.querySelectorAll('[data-slidecart-item="40172370690182"], [data-slidecart-item="39796293861510"], [data-slidecart-item="39589852184710"], [data-slidecart-item="31461251874950"]').length > 0){
      debouncedReviewCart();
    }
  });

} 
//
// END support for [IQB-02]
//

//
//
//
//
//

/* 

This module does a lot. It should be one-size-fits-most. With some setup, mostly defining css_selectors and some style tweaks

here are the main features:
- leverages (or creates) the cart:change event to update the cart_data object
- refreshes at adjustments to the cart object
- is injected into the cart
- supports proteus custom discounting logic
- offers GWP ATC functionality (in-cart)
- [in-progress] support for freeshipping messaging
- is embeddable anywhere via <div class="js-incentives--container"></div>

*/

/* 

// ASSETS: these could live anywhere

*/

const svg_gift = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
 <path d="m692.39 1141.3h339.32c5.4844 0 9.9375-4.4531 9.9375-9.9375v-537.74h-349.26z"/>
 <path d="m547.6 563.06v578.26h114.28v-770.58h-114.28z"/>
 <path d="m102.09 380.68v172.45c0 5.4844 4.4531 9.9375 9.9375 9.9375h405.05l-0.046875-192.32h-405c-5.4844 0-9.9375 4.4531-9.9375 9.9375z"/>
 <path d="m167.81 1131.4c0 5.4844 4.4531 9.9375 9.9375 9.9375h339.32l-0.046874-547.69h-349.22z"/>
 <path d="m1097.6 370.74h-405.19v192.32h405.19c5.4844 0 9.9375-4.4531 9.9375-9.9375v-172.45c0-5.4844-4.4531-9.9375-9.9375-9.9375z"/>
 <path d="m529.82 317.26c-1.2188-0.375-124.64-36.375-180.74-72.469-10.5-6.75-14.438-20.203-8.6719-31.266 13.406-24.938 24.141-38.438 24.75-39.281 0.65625-0.98438 16.266-24.328 44.906-6.6562 21.891 13.547 46.688 28.875 142.03 123.47l32.25 32.016-17.766-41.812c-90.375-213.14-145.82-216.98-186.37-219.79-39.047-2.6719-77.766 36.562-79.453 38.344-3.75 3.8906-91.547 96.516-46.031 169.31 39.234 62.766 232.26 65.672 267.52 65.672h5.25l60.141-0.75z"/>
 <path d="m954.74 269.11c45.516-72.797-42.234-165.37-46.078-169.36-1.6406-1.6875-40.688-41.25-79.406-38.25-40.5 2.8125-96 6.6094-186.37 219.79l-17.719 41.812 32.25-32.016c95.344-94.641 120.14-109.97 142.4-123.74 27.422-16.922 42.844 4.4531 45 7.5938 0.09375 0.14062 10.828 13.641 24.562 39.188 5.4375 10.453 1.4531 23.906-9 30.656-56.109 36.094-179.48 72.094-180.74 72.469l-57.797 16.781 60.141 0.75h5.25c35.297-0.046875 228.28-2.9531 267.52-65.672z"/>
</svg>`;

const svg_mixer = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
 <path d="m171.48 1084.4-89.863 12.84 39.715 39.711 89.863-12.836z"/>
 <path d="m138.72 1154.3 35.035 35.035c6.8594 6.8594 15.977 10.637 25.676 10.637 9.6953 0 18.816-3.7773 25.676-10.637 13.035-13.035 14.035-33.582 3.0625-47.812z"/>
 <path d="m114.38 1027.3-89.863 12.836 39.715 39.719 89.863-12.84z"/>
 <path d="m61.957 974.87c-6.8594-6.8594-15.98-10.637-25.676-10.637-9.6992 0-18.816 3.7773-25.676 10.637-13.035 13.039-14.035 33.582-3.0625 47.812l89.445-12.781z"/>
 <path d="m1194.4 147.59c-12.449-32.824-31.172-61.875-55.645-86.352-23.324-23.324-53.508-42.93-84.98-55.207-32.48-12.668-69.312-5-93.848 19.535l-176.78 176.78c-87.414 87.414-152.79 195.99-189.17 314.14l89.535 89.539c118.14-36.383 226.72-101.76 314.14-189.18l176.71-176.71c24.281-24.285 32.145-60.609 20.035-92.539zm-147.79 117.59c-14.93 14.93-34.781 23.152-55.895 23.152s-40.969-8.2227-55.898-23.152c-14.93-14.93-23.156-34.785-23.156-55.898 0-21.117 8.2266-40.969 23.156-55.902 14.93-14.93 34.785-23.152 55.898-23.152s40.969 8.2227 55.895 23.156c14.93 14.93 23.156 34.781 23.156 55.898 0 21.113-8.2266 40.969-23.156 55.898z"/>
 <path d="m990.7 149.89c-15.859 0-30.773 6.1758-41.992 17.395-11.215 11.215-17.395 26.129-17.395 41.992 0 15.859 6.1797 30.773 17.395 41.988 11.219 11.215 26.129 17.395 41.992 17.395 15.859 0 30.773-6.1758 41.988-17.395 11.215-11.215 17.395-26.129 17.395-41.988 0-15.863-6.1797-30.773-17.395-41.992-11.219-11.219-26.129-17.395-41.988-17.395z"/>
 <path d="m540.84 607.79c-11.746 11.746-13.711 29.586-5.9688 43.418l-391.35 391.32 13.91 13.91 391.34-391.32c5.3633 3.0156 11.426 4.6484 17.746 4.6484 9.6953 0 18.816-3.7773 25.676-10.637l58.305-58.305-51.348-51.348z"/>
</svg>`;

const svg_savings = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
 <path d="m816.28 82.359-82.078 195.89c-6.4688-1.8281-12.938-2.7656-20.062-2.7656h-228.61c-7.0781 0-13.594 0.9375-20.062 2.7656l-82.078-195.89c-4.0312-9.8906 6.4688-19.125 16.031-14.203l23.438 12.328c15.422 8.3438 33.609 8.3438 48.75 0l27.469-14.484c15.422-8.0156 33.609-8.0156 48.75 0l27.469 14.484c15.422 8.3438 33.609 8.3438 49.078 0l27.141-14.203c15.141-8.3438 33.328-8.3438 48.75-0.32812l27.469 14.812c15.422 8.0156 33.609 8.0156 49.078 0l23.766-12.656c9.2344-5.1562 19.688 4.4062 15.703 14.25zm-122.48 268.08h10.172l0.32812-0.60938c-3.4219 0.60938-6.7969 0.60938-10.5 0.60938zm20.953 789.56h-229.5c-183.89 0-319.31-90.703-297.42-302.06 16.641-160.45 99.656-350.16 241.26-438.1 13.875 15.422 34.266 25.312 56.484 25.312h228.61c22.547 0 42.562-9.8906 56.484-25.594 141.94 87.938 224.9 277.97 241.6 438.42 21.844 211.31-113.62 302.02-297.52 302.02zm-198.37-454.45c6.1875-40.406 52.734-52.453 76.5-53.062 17.297-0.9375 74.953 0.9375 90.375 44.719 1.2188 3.7031 2.1562 7.7344 2.4844 11.719 0.9375 8.625 8.9531 14.484 16.969 13.875 8.3438-0.60938 14.484-8.0156 13.875-16.641-0.60938-6.7969-2.1562-13.266-4.3125-19.453-12.938-37.031-48.422-60.141-96.891-64.5v-56.156c0-8.625-7.0781-15.422-15.422-15.422-8.625 0-15.422 6.7969-15.422 15.422v56.156c-43.5 4.0312-91.031 29.016-98.719 78.375-3.7031 24.984 3.375 49.688 20.062 70.031 21.281 25.312 54.609 40.125 93.469 41.016 29.906 0.9375 55.547 12.047 70.641 30.234 11.109 13.266 16.031 29.297 13.594 45.375-6.4688 40.125-53.062 52.453-76.828 53.062-17.297 0.60938-74.672-0.9375-90.094-44.719-1.5469-3.7031-2.4844-7.7344-2.7656-11.719-0.60938-8.625-8.0156-14.484-16.641-14.203-8.625 0.9375-14.812 8.3438-13.875 16.969 0.60938 6.4688 1.8281 13.266 4.0312 19.453 13.266 37.031 48.75 60.141 97.172 64.5v56.484c0 8.3438 6.7969 15.422 15.422 15.422 8.3438 0 15.422-7.0781 15.422-15.422v-56.484c43.5-4.0312 91.031-29.016 98.438-78.656 4.0312-24.703-3.0938-49.688-20.062-69.75-21-25.312-54.281-40.125-93.469-41.344-29.625-0.60938-55.547-11.719-70.641-29.906-11.156-13.312-15.75-29.625-13.312-45.375zm241.92-335.16c0-24.328-19.688-44.016-44.016-44.016h-228.71c-24.328 0-44.016 19.688-44.016 44.016s19.688 44.016 44.016 44.016h228.71c24.281 0 44.016-19.688 44.016-44.016z"/>
</svg>`;

const svg_shipping = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="1200pt" height="1200pt" version="1.1" viewBox="225 225 750 750" xmlns="http://www.w3.org/2000/svg">
 <path d="m978 613.69c-0.09375-16.5-4.6406-32.672-13.219-46.828l-72.703-111.38v0.046875c-12.469-15.141-31.031-23.859-50.625-23.766h-103.45v-65.531c-0.046875-9.9375-8.0625-17.953-18-18h-384c-4.7812 0-9.375 1.875-12.75 5.25s-5.25 7.9688-5.25 12.75v47.531h-78c-9.9375 0-18 8.0625-18 18s8.0625 18 18 18h147.14c9.9375 0 18 8.0625 18 18s-8.0625 18-18 18h-69.141v29.531h-78c-9.9375 0-18 8.0625-18 18s8.0625 18 18 18h180c9.9375 0 18 8.0625 18 18s-8.0625 18-18 18h-102v29.484h-45.375c-9.9375 0-18 8.0625-18 18s8.0625 18 18 18h114.52c9.9375 0 18 8.0625 18 18s-8.0625 18-18 18h-69.141v84.984c0.046875 9.8906 8.1094 17.906 18 18h56.625c8.3438 35.156 39.703 60 75.844 60s67.547-24.844 75.844-60h195.84c8.2969 35.156 39.703 60 75.844 60s67.547-24.844 75.844-60h68.156c9.8906-0.09375 17.953-8.1094 18-18zm-509.53 202.08c-16.969 0-32.297-10.219-38.812-25.922-6.4688-15.703-2.9062-33.75 9.1406-45.797 12-12 30.047-15.609 45.75-9.0938s25.922 21.797 25.922 38.812c-0.09375 23.156-18.844 41.906-42 42zm347.53 0c-16.969 0-32.297-10.219-38.812-25.922-6.4688-15.703-2.9062-33.75 9.0938-45.797 12.047-12 30.094-15.609 45.797-9.0938s25.922 21.797 25.922 38.812c-0.046875 23.203-18.797 41.953-42 42zm-78.234-240 0.23438-108h103.45c8.2031-0.14062 16.125 3.1875 21.844 9.0938l64.547 98.859z"/>
</svg>`

/*

// SETTINGS: probably best defined on theme.liquid (OR re-scoped proteus-utils.js eventually)
// at a minimum, this much liquid-generated JS needs to exist:

window.cart_data = {{ cart | json }};
{% assign gwp_product = all_products["modern-matcha-starter-set"] %}
window.gwp_product = {
  {% if gwp_product.available %}
    var_id: {{ gwp_product.selected_or_first_available_variant.id }},
    var_title: "{{ gwp_product.title }}",
    var_subtitle: "For Orders Over $100",
    var_value: "{{ gwp_product.price | money }}",
    var_img: "{{ gwp_product.images[0] | img_url: '600x' }}",
  {% endif %}
}

// then these values are custom per environment and need to be defined at setup + go through QA

*/

let promo_is_active = true;

window.cart_css_selector = 'cart-drawer'; // observed for changes
window.cart_header_css_selector = 'cart-drawer .drawer__content'; // where bar is injected by default
window.cart_header_placement = "beforebegin"; // pertaining to cart_header_css_selector
window.cart_items_css_selector = 'cart-drawer .drawer__content'; // where GWP is injected
window.original_shipping_bar_css_selector = 'free-shipping-bar';
window.atc_button_classes = "button button--primary button--small";

let free_shipping_threshold = 3000; // or subscription product
let gwp_source_prop = "BFCM"; // this will show in-cart as "source: [gwp_source_prop]"
let gwp_discount_prop = "BFCM 2025"; // this will not show in-cart but is used to activate discount

let incentives_thresholds = [
  {
    amount: 5000, 
    label: "Free Mixer",
    message: "Get a Free Mixer",
    threshold_icon: svg_gift,
    gwp_product: window.gwp_product,
    gwp_product_subtitle: "",
  },
];

// we use cart:change to update the cart_data object (see example)

///////////////////////////////
// using cart:change (example)
///////////////////////////////

/*
document.addEventListener("cart:change", (e) => {
  console.log("change data", e);
  window.cart_data = e.detail.cart;
});
*/

// cart:change is not always available. if it is, great (this is most-performant)
// otherwise we need to set it up

// sometimes it CAN be added into the theme.js's API calls, okay... but be careful (see example)

///////////////////////////////
// adding cart:change (example)
///////////////////////////////

/* 
fetch("/cart/add.js", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ items: [{ id: var_id, quantity: 1 }] }),
}).then(res => res.json()).then(cart => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:change", { detail: { cart } })
  );
});
*/

// we want a one-size-fits-all option. if cart:change is not available this method doesn't cause a lot of noise or traffic
// polling for DOM for changes, every 5s check the cart and get the data if updated -- (stable, low-impact, kinda slow)

async function update_cart_data() {
  try {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    if (!res.ok) throw new Error("Failed to fetch cart");
    const cart = await res.json();

    window.cart_data = cart;
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", { 
        detail: { cart },
        bubbles: true
      })
    );

    return cart;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return null;
  }
}

waitForElement(window.cart_css_selector).then(cart => {

  let current_state = cart.innerText.toLowerCase();
  setInterval(() => {
    if(document.querySelector(window.cart_css_selector).innerText.toLowerCase() != current_state){
      console.log("cart updated -- get data");
      update_cart_data();
      // set new current state
      current_state = document.querySelector(window.cart_css_selector).innerText.toLowerCase();
    }
  }, 2000); // 2s

}).catch();

//
// START -- [GLW-BFCM] 2025
//

/*

QA: ?bfcm2025=active

Treatment:
◦ • Offer: Buy More, Save More
    ◦ 15% off $50 + Modern Matcha Starter Set
    ◦ 20% off $100 + Modern Matcha Starter Set
    ◦ 25% off $150 + Modern Matcha Starter Set

Gift over $50 (Lemonade, latte, accessory - $15 ballpark) 
Fail safe for GWP OOS - Maybe a backup that just gives the percentage off and removed GWP
Consider bundles - https://www.jadeleafmatcha.com/collections/matcha-sets-bundles - Bundles will be listed at full list price 11/15-12/15 to account for automatic discounting used during the holidays.

Free Shipping remains at $60+ or free with subscription for the duration 


*/

if(window.location.href.indexOf("bfcm2025=active") > -1 || promo_is_active){
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      console.log(`init - ${gwp_discount_prop}`)
      gtm_add_cartAttribute("_discount", gwp_discount_prop);
    }, 3500);
  })
}

// GWP: (claim item, custom discount)
// discount applied
// free shipping 

if(window.sessionStorage.getItem("[GLW-BFCM] 2025 active") || window.location.href.indexOf("bfcm2025=active") > -1 || promo_is_active){
  window.sessionStorage.setItem("[GLW-BFCM] 2025 active", true);

  // inject styles
  waitForElement('body').then(doc => {

    doc.insertAdjacentHTML('afterbegin', `
      <style>
      ${window.original_shipping_bar_css_selector}{
        display: none !important;
      }
      .js-incentives--threshold{
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1em;
        font-size: 1.5em;
        padding: 3px;
        position: absolute;
        bottom: .5rem;
        left: 0;
        text-align: center;
        width: 1.5rem;
        height: 1.5rem;
        border: 1px solid;
        border-radius: 100%;
        background: #f5f5f5;
      }

      .js-incentives--threshold svg path{
        fill: #090d1c !important;
      }
        
      .js-incentives--threshold.js-met{
        background: #00a701;
      }

      .js-incentives--threshold.js-met svg path{
        fill: #00a701 !important;
      }

      .js-incentives--threshold.js-met svg path{
        fill: #fff !important;
      }

      .js-incentives--threshold span{
        font-size: 11px;
        position: absolute;
        top: 1.75rem;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
        line-height: .75em;
      }

      .js-incentives--threshold:last-child span{
        left: auto;
        right: 0;
        transform: none;
        width: 60px;
      }
      
      .js-incentives {
        position: relative;
        padding: 15px 0;
        margin: 0 2rem 1rem 1.5rem;
      }
      .js-incentives--message {
        text-align: center;
        font-size: .8em;
        margin-bottom: 10px;
        font-weight: 400;
        color: #090d1c;
      }
      .js-incentives--bar {
        border: 1px solid #090d1c;
        border-radius: 10px;
        overflow: hidden;
        height: 10px;
        background: #fff;
      }
      .js-incentives--fill {
        background: #a70000;
        height: 100%;
        transition: width 0.3s ease;
        min-width: 1px;
      }
      .js-incentives--fill.js-bar--filled {
        background: #00a701;
      }
      </style>
    `);

  }).catch();

  let update_incentives_bar = () => {
    console.log('update_incentives_bar()');

    let cart_total = cart_data.total_price;

    let incentives_thresholds_html = ``;
    for(let i = 0; i < incentives_thresholds.length; i++){
      incentives_thresholds_html += `
        <div class="js-incentives--threshold ${incentives_thresholds[i].amount <= cart_total ? 'js-met' : ''}" data-amount="${incentives_thresholds[i].amount}" 
        style="left: calc(${((i + 1) / incentives_thresholds.length)*100}% - 1rem);">${incentives_thresholds[i].threshold_icon}
          <span>${incentives_thresholds[i].label}</span>
        </div>
      `;
    }

    let js_incentives_html = `
      <div class="js-incentives">
        <div class="js-incentives--message"></div>
        <div class="js-incentives--bar">
          <div class="js-incentives--fill">&nbsp;</div>
        </div>
        ${incentives_thresholds_html}
      </div>
    `;
    
    if(document.querySelectorAll(`${window.cart_css_selector} .js-incentives`).length == 0){
      // build .js-incentives in DOM
      waitForElement(window.cart_header_css_selector).then(drawer_header => {
        drawer_header.insertAdjacentHTML(window.cart_header_placement, js_incentives_html);
      }).catch();
    }

    // update embedded_incentives
    let embedded_incentives = document.querySelectorAll('.js-incentives--container')
    for(let i = 0; i < embedded_incentives.length; i++){
      if(embedded_incentives[i].querySelectorAll(".js-incentives").length == 0){
        embedded_incentives[i].innerHTML = js_incentives_html;
      }
    }

    observeSelector('.js-incentives', js_incentives => {

      let bar_fill = js_incentives.querySelector('.js-incentives--fill');
      let progress_message = js_incentives.querySelector('.js-incentives--message');
      let max_met_threshold = 0;
      
      // Update UI
      let thresholds = js_incentives.querySelectorAll('.js-incentives--threshold');
      for(let i = 0; i < incentives_thresholds.length; i++){

        if(cart_total >= incentives_thresholds[i].amount){
          thresholds[i].classList.add("js-met");
          max_met_threshold = i;
        } else {
          thresholds[i].classList.remove("js-met");
        }
        
        if(incentives_thresholds[i].amount >= cart_total){

          if(i > 0){
            progress_message.innerHTML = `
              You ${incentives_thresholds[i - 1].message}.<br>Spend <span style="color: #a70000;"><strong>$${((incentives_thresholds[i].amount - cart_total) / 100).toFixed(2)}</strong></span> more and ${incentives_thresholds[i].message}
            `;
          } else {
            progress_message.innerHTML = `
              Spend <span style="color: #a70000;"><strong>$${((incentives_thresholds[i].amount - cart_total) / 100).toFixed(2)}</strong></span> more and ${incentives_thresholds[i].message}
            `;
          }
          break;

        } else if(i == incentives_thresholds.length - 1){
          progress_message.innerHTML = `
            <span style="color: #00a701;">You ${incentives_thresholds[incentives_thresholds.length - 1].message}</span>
          `;
        }
      }

      if(cart_total/incentives_thresholds[incentives_thresholds.length - 1].amount >= 1){
        bar_fill.style.width = "100%";
        bar_fill.classList.add("js-bar--filled");
      } else {
        bar_fill.classList.remove("js-bar--filled");
        let active_threshold_goal = max_met_threshold >= 0 ? max_met_threshold : 0;
        let progress_to_threshold = cart_total/incentives_thresholds[active_threshold_goal].amount;
        bar_fill.style.width = `calc(${((active_threshold_goal + 1) / incentives_thresholds.length * progress_to_threshold)*100}% - .25rem)`;
      }

      if(max_met_threshold >= 0 &&
      !!incentives_thresholds[max_met_threshold].gwp_product.var_id && 
      cart_total >= incentives_thresholds[0].amount){

        setTimeout(() => {

          if(document.querySelectorAll(`${window.cart_items_css_selector} .js-offer`).length == 0 && 
          document.querySelector(window.cart_css_selector).innerText.toLowerCase().indexOf("source: bfcm") == -1 &&
          cart_data.items.filter(item => item.properties?.source === gwp_source_prop && item.variant_id == incentives_thresholds[max_met_threshold].gwp_product.var_id).length == 0){

            document.querySelector(window.cart_items_css_selector).insertAdjacentHTML("afterbegin", `
              <div class="js-offer--container">
                <style>
                .js-offer{
                    background: #e7f2f6 url(${incentives_thresholds[max_met_threshold].gwp_product.var_img}) no-repeat;
                    background-size: auto 90%;
                    background-position: left center;
                    margin: 1rem 0;
                    padding: 1rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                
                .js-offer > div:first-child{
                    padding-left: 100px;
                }
                .js-offer > div:last-child{
                    /* text-align: center; */
                }
                .js-offer > div span{
                    display: block;
                    font-size: .75rem;
                }
                .js-offer > div:last-child span{
                    margin-top: -.5rem;
                }
                .js-offer .js-gwp-atc{
                    transform: scale(.65);
                    transform-origin: left center;
                    cursor: pointer;
                }
                @media(max-width: 525px){
                    .js-offer{
                        display: block;
                    }
                    .js-offer > div:last-child{
                        text-align: left;
                        margin-left: 0;
                    }        
                    .js-offer .js-gwp-atc{
                        margin-left: 0;
                    }   
                    .js-offer > div:last-child span{
                        margin-left: 0;
                    }
                }

                </style>
                <div class="js-offer">
                    <div>
                        Claim your <strong>FREE</strong> ${incentives_thresholds[max_met_threshold].gwp_product.var_title}
                        <div><span>${incentives_thresholds[max_met_threshold].gwp_product_subtitle}</span></div>
                        <div>
                          <div class="js-gwp-atc ${window.atc_button_classes}" data-var-id="${incentives_thresholds[max_met_threshold].gwp_product.var_id}" data-prop="BFCM 2025">Add to Cart</div>
                          <span>a ${incentives_thresholds[max_met_threshold].gwp_product.var_value} value</span>
                      </div>
                    </div>
                    
                </div>
              </div>
            `)

            waitForElement('.js-gwp-atc').then(gwp_atc => {

              let var_id = gwp_atc.getAttribute("data-var-id");

              gwp_atc.addEventListener("click", () => {

                add_gwp_item(var_id);
                gwp_atc.remove();
              
              });

            }).catch();
          }

        }, 0);

      } else if(document.querySelectorAll('.js-offer--container').length > 0){
        document.querySelector('.js-offer--container').remove();
      }

    }); // observeSelector('.js-incentives')
    
  }

  // init
  setTimeout(() => {
    update_incentives_bar();
  }, 500)

  document.addEventListener("cart:change", (e) => {
    console.log("its a cart change!", e.detail);
    update_incentives_bar();
  });

  let current_cart_data = window.cart_data;
  observeSelector(window.cart_items_css_selector, cart_contents => {
    setTimeout(() => {
      if(current_cart_data != window.cart_data){
        update_incentives_bar();
        current_cart_data = window.cart_data;
      }
    }, 0)
  })

}

refresh_cart = () => {
  // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external' });
  // document.querySelector(`${window.cart_items_css_selector} input[name="quantity"]`).dispatchEvent(new Event('change', { bubbles: true }));
  setTimeout(() => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh")
    );
  }, 1500)
}

async function add_gwp_item(var_id) {
  
  try {
    // find + remove any line items added from GWP
    const gwp_items = cart_data.items.filter(item => item.properties?.source === gwp_source_prop);
    for (const item of gwp_items) {
      console.log("Removing existing gwp item:", item.id);
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    }

    // add the gwp item
    const cart_add_gwp_item = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: var_id,
            quantity: 1,
            properties: {
              source: gwp_source_prop,
              _discount: gwp_discount_prop,
            },
          },
        ],
      }),
    });

    const data = await cart_add_gwp_item.json();
    console.log("added gwp item:", data);

    refresh_cart();

  } catch (err) {
    console.error("Error updating cart:", err);
  }
}